export const gtmEventTypes = {
  REGISTER_YOUR_INTEREST_FORM: 'RYIF-001',
}

export const gtmEvents = {
  [gtmEventTypes.REGISTER_YOUR_INTEREST_FORM]: ({nameplate}) => ({
    type: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    pageCategory: 'Register Your Interest Form',
    pageAction: `Register Your Interest Form - "${nameplate}" - Clicked "KEEP ME INFORMED".`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/register-interest-duck.js